import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "./../../components/panel/panel.jsx";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Select from "react-select";
import DropDownStyles from "./dropdownStyles.js";
import axiosInstance from "../../config/axiosApi/axiosApi.jsx";
import StaffTabBar from "./staffTabBar.js";
import APIs from "../../Constants/apis.js";
import Preloader from "../../components/CustomComponents/preLoad/preLoader.js";
import showErrorToast, {
  showSuccessToast,
} from "../../components/CustomComponents/toast/toast.js";
import FormInput from "../../components/CustomComponents/Input/formInput.jsx";
import ToggleSwitch from "../../components/CustomComponents/Switchery/switchery.jsx";
import CommonTimeSlotForAllWeek from "../../components/CustomComponents/TimeSchedule/commonTimeSlotForAllWeek.js";
import ScheduleManager from "../../components/CustomComponents/TimeSchedule/weeklySlots.js";
import schedule from "../../components/CustomComponents/TimeSchedule/schedule.js";
import moment from "moment";
import "react-datetime/css/react-datetime.css";
import { checkIfCommonTimeSlots, convertToScheduleFormat } from "../../components/CustomComponents/TimeSchedule/scheduleConv.js";

function UpdateStaff() {
  const { UserName } = useParams();
  const navigatore = useNavigate();
  const CompID = useSelector((state) => state.auth.user).userData?.compID;
  const [roles, setRoles] = useState([]);
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState({});
  const [selectedRole, setSelectedRole] = useState({});
  const [staffData, setStaffData] = useState({
    userName: "",
    firstName: "",
    lastName: "",
    email: "",
    country: "UK",
    phoneNo: "",
    passCode: "",
    ratePerHour: 0,
    active: false,
    userRoles: null,
    IsBreakAllowed: false,
    BreakMinutes: null,
  });
  const [regularHours, setRegularHours] = useState(true);
  const [useSameTimeSlots, setUseSameTimeSlots] = useState(true);
  const [commonTimeSlot, setCommonTimeSlot] = useState([
    {
      from: "9:30 AM",
      to: "1:00 PM",
    },
  ]);

  const [schedules, setSchedules] = useState(schedule);

  const FetchRoles = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        APIs.GET_ROLES + `?CompID=${CompID}`
      );
      const roleData = response.data.data || response.data;
      const rolesOptions = roleData.map((role) => ({
        value: role.comRolePermission_ID,
        label: role.r_Title,
      }));
      setRoles(rolesOptions);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, [CompID]);

  const FetchCountries = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(APIs.GET_COUNTRIES);
      const roleData = response.data.data || response.data;
      const mappedOptions = roleData.map((country) => ({
        value: country.code,
        label: country.name,
      }));
      setCountries(mappedOptions);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, []);

 

  const FetchStaffData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(APIs.GET_STAFF_DATA, {
        params: {
          CompID,
          UserName,
        },
      });
      const staff = response.data.data || response.data;
     
      if (staff.weeklySchedule && Array.isArray(staff.weeklySchedule) && staff.weeklySchedule.length > 0) {
        setRegularHours(false);
        const isCommon = checkIfCommonTimeSlots(staff.weeklySchedule);
        if (isCommon) {
          const firstDaySlots = staff.weeklySchedule
            .filter(
              (day) => day.dayName === staff.weeklySchedule[0].dayName
            )
            .map((day) => ({
              from: day.openTime,
              to: day.closeTime,
            }));

          setCommonTimeSlot(firstDaySlots);
        } else {
          setUseSameTimeSlots(false);
          const convertedSchedules = convertToScheduleFormat(staff.weeklySchedule);
          setSchedules(convertedSchedules);
        }
      }
      else
        setSchedules(schedule)

      setSelectedCountry(countries.find((c) => c.value === staff.country));
      setSelectedRole(roles.find((r) => r.value === staff.comRolePermission_ID));
       
      setStaffData({
        ...staff,
        isBreakAllowed: staff.isBreakAllowed || false,
        breakMinutes: staff.breakMinutes,
      });

    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, [CompID, UserName, countries, roles]);

  useEffect(() => {
    const fetchData = async () => {
      await Promise.all([FetchRoles(), FetchCountries()]);
    };

    fetchData();

  }, [FetchRoles, FetchCountries]);

  useEffect(() => {
    if (countries.length > 0 && roles.length > 0) {
      FetchStaffData();
    }
  }, [countries, roles, FetchStaffData]);

  const applyCommonTimeSlotToAll = () => {
    const updatedSchedules = schedules.map((schedule) => ({
      ...schedule,
      timeSlots: commonTimeSlot.map((slot) => ({ ...slot })),
    }));
    setSchedules(updatedSchedules);
  };

  const handleSubmit = async () => {
    const {
      userName,
      firstName,
      lastName,
      email,
      country,
      passCode,
      phoneNo,
      ratePerHour,
      active,
      isBreakAllowed,
      breakMinutes,
    } = staffData;
  
    if (
      !userName ||
      !firstName ||
      !lastName ||
      !email ||
      !country ||
      !passCode
    ) {
      showErrorToast("Please fill in all required staff fields.");
      return;
    }

    if (!selectedRole?.value) {
      showErrorToast("Please select a staff role.");
      return;
    }
  
    const formattedSchedules = [];
  
    if (!regularHours) {
      if (useSameTimeSlots) {
        const days = [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ];
        days.forEach((day) => {
          // If there are time slots, add them; otherwise, explicitly set an empty array
          if (commonTimeSlot.length > 0) {
            commonTimeSlot.forEach((slot) => {
              formattedSchedules.push({
                ID: 0,
                CompID: CompID,
                UserName: UserName,
                DayName: day,
                  OpenTime: moment(slot.from, ["h:mm A"]).format("hh:mm A"),
                  CloseTime: moment(slot.to, ["h:mm A"]).format("hh:mm A"),
                UpdateDateTime: new Date().toISOString(),
              });
            });
          }  
        });
      } else {
        // Process each day of the schedule separately
        schedules.forEach((schedule) => {
          if (schedule.checked && schedule.timeSlots.length > 0) {
            // Process checked days with time slots
            schedule.timeSlots.forEach((slot) => {
              if (
                moment(slot.from, ["h:mm A"]).isValid() &&
                moment(slot.to, ["h:mm A"]).isValid()
              ) {
                formattedSchedules.push({
                  ID: 0,
                  CompID: CompID,
                  UserName: UserName,
                  DayName: schedule.day,
                  OpenTime: moment(slot.from, ["h:mm A"]).format("hh:mm A"),
                  CloseTime: moment(slot.to, ["h:mm A"]).format("hh:mm A"),
                  UpdateDateTime: new Date().toISOString(),
                });
              }
            });
          }  
        });
      }
    }
  
    try {
      setLoading(true);
      await axiosInstance.put(APIs.UPDATE_STAFF, {
        UserName: userName,
        FirstName: firstName,
        LastName: lastName,
        Email: email,
        Country: country,
        PhoneNo: phoneNo,
        PassCode: passCode,
        RatePerHour: ratePerHour,
        Active: active,
        Password: "",
        CompID: CompID,
        ComRolePermission_ID: selectedRole.value,
        IsBreakAllowed: isBreakAllowed ,
        BreakMinutes: breakMinutes || 0,
      });

      await axiosInstance.put(APIs.UPDATE_STAFF_WEEKLY_SCHEDULE, regularHours ? [] : formattedSchedules, {
        params: {
          Username: userName,
          CompID,
        },
      });
  
      setLoading(false);
      showSuccessToast("Staff updated successfully!");
      navigatore("/staff/manageStaff");
    } catch (error) {
      setLoading(false);
      console.error(error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        showErrorToast(error.response.data.message);
      } else {
        showErrorToast("Failed to update staff or schedule.");
      }
    }
  };

  return (
    <div>
      {loading && <Preloader />}
      <div className="d-flex align-items-center mb-2 mt-2">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Home</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/staff/manageStaff">Manage Staff</Link>
            </li>
            <li className="breadcrumb-item active">Update Staff</li>
          </ol>
          <h1 className="page-header mb-0">
            Update Staff ({UserName})
          </h1>
        </div>
        <div className="ms-auto">
          <button
            onClick={handleSubmit}
            className="btn btn-success btn-rounded px-4 rounded-pill"
          >
            <i className="fa-lg me-2 ms-n2 text-success-900"></i>
            Submit
          </button>
        </div>
      </div>
      <div className="card border-0">
        <StaffTabBar
          activeTab="updateInfo"
          useTab="false"
          UserName={UserName}
        />
        {/* Staff Information Section */}
        <Panel className="m-3">
          <PanelHeader>Staff Information</PanelHeader>
          <PanelBody>
            <div className="row mb-3">
              <div className="col-6">
                <FormInput
                  label="User Name"
                  placeHolder="Enter User Name"
                  type="text"
                  value={staffData.userName}
                  readOnly={true}
                  onchange={(e) =>
                    setStaffData({ ...staffData, userName: e.target.value })
                  }
                />
              </div>
              <div className="col-6">
                <FormInput
                  label="First Name"
                  placeHolder="Enter First Name"
                  type="text"
                  value={staffData.firstName}
                  onchange={(e) =>
                    setStaffData({ ...staffData, firstName: e.target.value })
                  }
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-6">
                <FormInput
                  label="Last Name"
                  placeHolder="Enter Last Name"
                  type="text"
                  value={staffData.lastName}
                  onchange={(e) =>
                    setStaffData({ ...staffData, lastName: e.target.value })
                  }
                />
              </div>
              <div className="col-6">
                <FormInput
                  label="Email"
                  placeHolder="Enter Email"
                  type="email"
                  value={staffData.email}
                  onchange={(e) =>
                    setStaffData({ ...staffData, email: e.target.value })
                  }
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-6">
                <label>Country</label>
                <Select
                  value={selectedCountry}
                  onChange={(option) => {
                    setSelectedCountry(option);
                    setStaffData({ ...staffData, country: option.value });
                  }}
                  options={countries}
                  styles={DropDownStyles}
                />
              </div>
              <div className="col-6">
                <label>User Roles</label>
                <Select
                  value={selectedRole}
                  onChange={(option) => {
                    setSelectedRole(option);
                    setStaffData({ ...staffData, userRoles: option.value });
                  }}
                  options={roles}
                  styles={DropDownStyles}
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-6">
                <FormInput
                  label="Phone Number"
                  placeHolder="Enter Phone Number"
                  type="text"
                  value={staffData.phoneNo}
                  onchange={(e) =>
                    setStaffData({ ...staffData, phoneNo: e.target.value })
                  }
                />
              </div>
              <div className="col-6">
                <FormInput
                  label="Pass Code"
                  placeHolder="Enter Pass Code"
                  type="text"
                  value={staffData.passCode}
                  onchange={(e) =>
                    setStaffData({ ...staffData, passCode: e.target.value })
                  }
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-6">
                <FormInput
                  label="Rate Per Hour"
                  placeHolder="Enter Rate Per Hour"
                  type="text"
                  value={staffData.ratePerHour}
                  onchange={(e) =>
                    setStaffData({
                      ...staffData,
                      ratePerHour: e.target.value,
                    })
                  }
                />
              </div>
            </div>
            <div className=" col-3 me-4">
              <ToggleSwitch
                isChecked={staffData.active}
                onToggle={(e) =>
                  setStaffData({ ...staffData, active: e.target.checked })
                }
                label="Active"
                name="active"
              />
            </div>

            <div className="mt-4 mb-3">
              <ToggleSwitch
                isChecked={staffData.isBreakAllowed}
                onToggle={(e) =>
                  setStaffData({
                    ...staffData,
                    isBreakAllowed: e.target.checked,
                    breakMinutes: e.target.checked ? staffData.breakMinutes : "",
                  })
                }
                label="Break Time"
                name="breakTimeEnabled"
              />
            </div>

            {staffData.isBreakAllowed && (
              <div className="col-6">
                <FormInput
                  label="Break Time (Minutes)"
                  placeHolder="Enter Break Time"
                  type="int"
                  value={staffData.breakMinutes}
                  onchange={(e) =>
                    setStaffData({
                      ...staffData,
                      breakMinutes: e.target.value,
                    })
                  }
                />
              </div>
            )}

            <div className="col-8 mb-3 mt-3">
              <ToggleSwitch
                isChecked={regularHours}
                onToggle={() => setRegularHours(!regularHours)}
                label={"Official Business Hours"}
                disabled={false}
              />
            </div>

            {!regularHours && (
              <div className="row m-3">
                <div className="mb-3">
                  <ToggleSwitch
                    isChecked={useSameTimeSlots}
                    onToggle={() => {
                      setUseSameTimeSlots(!useSameTimeSlots);
                      if (!useSameTimeSlots) {
                        applyCommonTimeSlotToAll();
                      }
                    }}
                    label={"Use same time slots for all days"}
                    disabled={false}
                  />
                </div>
                {useSameTimeSlots ? (
                  <CommonTimeSlotForAllWeek
                    setCommonTimeSlots={setCommonTimeSlot}
                    commonTimeSlots={commonTimeSlot}
                  />
                ) : (
                  <ScheduleManager
                    schedules={schedules}
                    setSchedules={setSchedules}
                  />
                )}
              </div>
            )}
          </PanelBody>
        </Panel>
      </div>
    </div>
  );
}

export default UpdateStaff;
